// extracted by mini-css-extract-plugin
export default {"cta":"ZI-z","disabled":"_I-z"};